module.exports = __webpack_public_path__ + "img/优惠券.abed4703.png";